import { Directive, Input, output } from '@angular/core';
import { ToolingTaskUpsertModel } from '../upsert-tooling-task-wizard.component';
import { ToolingDescriptionStepComponent } from './description-step/description-step.component';
import { ToolingStepComponent } from './tooling-step/tooling-step.component';
import { ToolingDocumentsStepComponent } from './documents-step/documents-step.component';
import { ToolingSchedulingStepComponent } from './scheduling-step/scheduling-step.component';
import { UntypedFormGroup } from '@angular/forms';

export type StepComponent =
  | ToolingDescriptionStepComponent
  | ToolingStepComponent
  | ToolingDocumentsStepComponent
  | ToolingSchedulingStepComponent;

@Directive()
export class ToolingStepBaseComponent {
  @Input() public toolingTaskModel: ToolingTaskUpsertModel;
  public readonly toolingTaskModelChange = output<ToolingTaskUpsertModel>();

  public stepForm = new UntypedFormGroup({});

  public get valid(): boolean {
    return this.stepForm?.valid;
  }
}
